export default "__VITE_ASSET__BbH6NHf6__"